import zhouchang from '@/assets/jiujuTeam/zhouchang.png'
import defaultIcon from '@/assets/jiujuTeam/default.png'
import zongshumei from '@/assets/jiujuTeam/zongshumei.png'
import gaotao from '@/assets/jiujuTeam/gaotao.png'
import yangyi from '@/assets/jiujuTeam/yangyi.png'
import songxiaojie from '@/assets/jiujuTeam/songxiaojie.png'
import xiexiaoming from '@/assets/jiujuTeam/xiexiaoming.png'
import fengshimeng from '@/assets/jiujuTeam/fengshimeng.png'
import gujuncai from '@/assets/jiujuTeam/gujuncai.png'
import wangzhe from '@/assets/jiujuTeam/wangzhe.png'
import lige from '@/assets/jiujuTeam/lige.png'
import biying from '@/assets/jiujuTeam/biying.png'
import hanyue from '@/assets/jiujuTeam/hanyue.png'
import zhouchangP from '@/assets/jiujuTeam/zhouchang_p.png'
import defaultIconP from '@/assets/jiujuTeam/default_p.png'
import zongshumeiP from '@/assets/jiujuTeam/zongshumei_p.png'
import gaotaoP from '@/assets/jiujuTeam/gaotao_p.png'
import yangyiP from '@/assets/jiujuTeam/yangyi_p.png'
import songxiaojieP from '@/assets/jiujuTeam/songxiaojie_p.png'
import xiexiaomingP from '@/assets/jiujuTeam/xiexiaoming_p.png'
import fengshimengP from '@/assets/jiujuTeam/fengshimeng_p.png'
import gujuncaiP from '@/assets/jiujuTeam/gujuncai_p.png'
import wangzheP from '@/assets/jiujuTeam/wangzhe_p.png'
import ligeP from '@/assets/jiujuTeam/lige_p.png'
import biyingP from '@/assets/jiujuTeam/biying_p.png'
import hanyueP from '@/assets/jiujuTeam/hanyue_p.png'
import zhouchangPink from '@/assets/jiujuTeam/zhouchang_pink.png'
import defaultIconPink from '@/assets/jiujuTeam/default_pink.png'
import zongshumeiPink from '@/assets/jiujuTeam/zongshumei_pink.png'
import gaotaoPink from '@/assets/jiujuTeam/gaotao_pink.png'
import yangyiPink from '@/assets/jiujuTeam/yangyi_pink.png'
import songxiaojiePink from '@/assets/jiujuTeam/songxiaojie_pink.png'
import xiexiaomingPink from '@/assets/jiujuTeam/xiexiaoming_pink.png'
import fengshimengPink from '@/assets/jiujuTeam/fengshimeng_pink.png'
import gujuncaiPink from '@/assets/jiujuTeam/gujuncai_pink.png'
import wangzhePink from '@/assets/jiujuTeam/wangzhe_pink.png'
import ligePink from '@/assets/jiujuTeam/lige_pink.png'
import biyingPink from '@/assets/jiujuTeam/biying_pink.png'
import hanyuePink from '@/assets/jiujuTeam/hanyue_pink.png'
const  dataList = [
    {
        id: 1,
        name: '周畅',
        position:'主任、创始人',
        phone: '13614011888',
        language:'中文',
        code: '12101 201010179661',
        year:'16',
        educationalBackground:'本科--中国政法大学，法学专业',
        careerField:'不良资产处置 / 金融投资',
        professionalQualification:'中华人民共和国执业律师投资项目分析师',
        personalProfile:'为金融机构和农村信用合作社转为农商行过程中对不良资产出表、不良资产剥离等相关业务有丰富经验及案例，对银行委托的诉讼外委、逾期贷款、信用卡清收外委等业务有成熟团队。对不良资产的收购、处置、管理，银行的金融外包服务等业务方面有着丰富的经验。为企业辅导挂牌上市，资本运作等方面有成功案例',
        socialAppointment:'中国民主建国会沈阳市委员会会员 / 境外上市国际律师联盟秘书长 / 沈阳市电子商务协会副会长 / 中国狮子联会会员',
        honors:'2015年荣获全国《第八届刑事辩护高峰论坛会》优秀刑事辩护律师 / 2016年获得中国商业联合会颁发的投资项目分析师',
        img: zhouchang,
        imgPersonal:zhouchangP,
        imgPink:zhouchangPink
    },
    {
        id: 2,
        name: '宗淑梅',
        position:'高级合伙人、创始人',
        phone: '15524105105',
        language:'中文/英文',
        code: '12101 200911419283',
        year:'17',
        educationalBackground:'本科-辽宁大学，法学专业',
        careerField:'刑事辩护 / 商事纠纷 / 合同纠纷 / 建设工程纠纷',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'本人视野开阔、思维活跃、逻辑严密、作风稳健，擅长民商法（含合同法、公司法、房地产法、婚姻家庭、劳动争议等）、刑事辩护、对银行委托的诉讼外委、逾期借款等业务有丰富的从业经验。从业以来成功代理多起争议标的金额大，法律关系复杂、具有较大社会影响的诉讼案件，对于案件要点把握准确，擅长收集、梳理案件证据材料，能够充分维护当事人的合法权益。',
        socialAppointment:'中国民主建国会沈阳市委员会会员 / 沈阳市仲裁委员会仲裁员 / 沈阳市律协企业法律顾问委员会委员 / 沈阳市律协合同法委员会委员 / 沈阳市律协刑法委员会委员 / 沈阳市律协侵权委员会委员 / 沈阳市非物质文化遗产协会理事 / CIID中室学沈阳市内建筑师中心委员 / 同泽高级中学法制副校长 / ',
        honors:'2011年沈阳市法律援助先进个人 / 2022年度优秀仲裁员 / 2023年第三届沈阳仲裁委员会仲裁员 “沈仲之星',
        img: zongshumei,
        imgPersonal:zongshumeiP,
        imgPink:zongshumeiPink
    },
    {
        id: 3,
        name: '高涛',
        position:'副主任、合伙人',
        phone: '15242488556',
        language:'中文',
        code: '12101 201011596094',
        year:'16',
        educationalBackground:'本科-辽宁大学，法学专业',
        careerField:'民商事纠纷 / 刑事、行政诉讼',
        professionalQualification: '中华人民共和国执业律师',
        personalProfile:'擅长于公司业务、合同法、房地产法、税法等诉讼与非诉讼业务，兼攻刑事辩护、行政诉讼。从业以来成功代理多起争议标的额大、法律关系复杂、具有较大影响的诉讼案件。同时担任多家公司的法律顾问。具有丰富的律师实务经验、深厚的法律功底。',
        socialAppointment:'大南二校法制副校长',
        honors:'2015年—2017辽宁法制报维权律师团律师 / 辽宁公益普法宣讲团讲师',
        img: gaotao,
        imgPersonal:gaotaoP,
        imgPink:gaotaoPink
    },
    {
        id: 4,
        name: '杨溢',
        position:'副主任、合伙人',
        phone: '13516002125',
        language:'中文/英文',
        code: '12101 200910656586',
        year:'17',
        educationalBackground:'本科-辽宁大学，计算机信息管理专业',
        careerField:'刑事诉讼 / 民商事纠纷',
        professionalQualification:'中华人民共和国执业律师 / 三级心理咨询师 / SAC证券从业资格',
        personalProfile:'在刑事辩护、民商事案件代理、为企业、政府机关提供法律顾问服务等领域取得了较好的成绩，积累了丰富的经验，执业以来一直秉承“以事实为依据，以法律为准绳”的原则，以维护当事人的合法权益为己任，敬畏法律，忠于事实，诚实守信、执业为民。杨律师还热心参与社区法律公益服务，深得当事人好评。杨律师为人谦和，办案认真、务实，是一名值得信赖的律师。',
        socialAppointment:'沈阳市仲裁委员会仲裁员 / 沈阳市公共法律服务中心法援公益律师 / 沈阳市非物质文化遗产协会理事 / CIID中室学沈阳市内建筑师中心委员 / 沈阳市律协企业法律顾问委员会（合同法委员会、刑法委员会、侵权委员会）委员',
        honors:'',
        img: yangyi,
        imgPersonal:yangyiP,
        imgPink:yangyiPink
    },
    {
        id: 5,
        name: '宋晓杰',
        position:'执业律师',
        phone: '13555889705',
        language:'中文',
        code: '12101 200911546948',
        year:'17',
        educationalBackground:'本科-辽宁大学，法学专业 / 研究生-大连理工大学，MBA',
        careerField:'民商事纠纷 / 投融资业务',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'专注于民商事诉讼及执行、金融不良债权清收、公司治理、融资服务等，先后成功处理过多个向公司股东追偿，以及涉及国有企业改制的相关债权项目，具有丰富的执业经验和深厚的法学理论功底，熟悉司法程序，具有良好的社会资源。具备大中型企业法律顾问的工作经验，熟悉公司、房地产、建设工程、经济合同、劳动争议等相关法律法规，办理过大量诉讼及非诉法律业务。以精湛的业务水准，优良的服务品质，良好的职业首先为客户提供最优质的法律服务。',
        socialAppointment:'',
        honors:'',
        img: songxiaojie,
        imgPersonal:songxiaojieP,
        imgPink:songxiaojiePink
    },
    {
        id: 6,
        name: '谢晓明',
        position:'执业律师',
        phone: '18802419058',
        language:'中文',
        code: '12101 200910362394',
        year:'17',
        educationalBackground:'本科-吉林大学、法学专业',
        careerField:'刑事辩护 / 民商事诉讼',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'实践经验丰富、理论功底扎实，主要致力于刑事辩护及疑难复杂的民、商事诉讼及公司企业法律事务并擅于化解企业危机，为多家企业提供常年法律顾问服务。随着律师业务的多元化和转型，谢晓明律师在保持原有传统诉讼业务风格的基础上，还将进一步致力于企业的资产置换、兼并、破产重整、股权诉讼及民商事领域的重大执行案案的理论研究和实践。',
        socialAppointment:'',
        honors:'',
        img: xiexiaoming,
        imgPersonal:xiexiaomingP,
        imgPink:xiexiaomingPink
    },
    {
        id: 7,
        name: '王彦明',
        position:'执业律师',
        phone: '13940588037',
        language:'中文',
        code: '12101 201810057077',
        year:'8',
        educationalBackground:'',
        careerField:'银行金融',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'对银行委托的诉讼外委、逾期贷款、信用卡清收外委等业务有丰富经验，处理各类非诉项目，其中在对不良债权资产包进行维护、清收工作，在该领域有一定的经验及成果。',
        socialAppointment:'',
        honors:'',
        img: defaultIcon,
        imgPersonal:defaultIconP,
        imgPink:defaultIconPink
    },
    {
        id: 8,
        name: '冯诗萌',
        position:'执业律师',
        phone: '18940002572',
        language:'中文',
        code: '12101 201911099728',
        year:'7',
        educationalBackground:'本科-辽宁师范大学-法学专业',
        careerField:'婚姻家事 / 民商事',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'在合同纠纷、劳动争议、婚姻家庭纠纷等各类民商事纠纷领域拥有丰富办案经验。冯诗萌律师一直秉承专业、敬业的理念，保持严谨的工作态度，为客户提供高质量、高效率的法律服务，在最大限度内维护当事人的合法权益。',
        socialAppointment:'',
        honors:'',
        img: fengshimeng,
        imgPersonal:fengshimengP,
        imgPink:fengshimengPink
    },
    {
        id: 9,
        name: '谷俊材',
        position:'执业律师',
        phone: '13478367100',
        language:'中文',
        code: '12101 202210488679',
        year:'4',
        educationalBackground:'',
        careerField:'建筑工程 / 刑事辩护',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'建筑工程与刑事辩护专业律师，具有多年工程项目管理和企业法务工作经验，曾先后在上市公司及建设单位担任项目经理和法务，民事领域：在工程招投标、合同签订及履行、工期和质量索赔与反索赔、商品房买卖合同、民间借贷领域有着丰富经验。在刑事辩护领域在中多次办理不起诉案件，曾多次参与省内重大刑事案件，其中包括担任东北首例组织出卖人体器官罪案主犯辩护律师。',
        socialAppointment:'沈阳市律协刑事法律委员会委员',
        honors:'',
        img: gujuncai,
        imgPersonal:gujuncaiP,
        imgPink:gujuncaiPink
    },
    {
        id: 10,
        name: '王哲',
        position:'执业律师',
        phone: '18842626364',
        language:'中文',
        code: '12101 202310602011',
        year:'3',
        educationalBackground:'研究生--法学专业',
        careerField:'企业合规 / 民商事诉讼',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'曾就职于大连市某检察院、北京某法律咨询公司，担任多家国企、外企、民企常年法律顾问，常年从事民商事诉讼及理论问题研究，具有丰富经验，对企业合规及法律风险防范有深刻理解。曾参与大连法治化营商环境指标体系构建研究等科研项目。专注金融资产处置、知识产权侵权、企业合规、商事争议解决等领域',
        socialAppointment:'辽宁省劳动人事争议研究会副秘书长/法制宣传教育工作委员会委员/辽宁省法学会知识产权法学研究会专家/辽宁省侵权责任法研究会研究基地专家/辽宁省百人金牌讲师团副团长',
        honors:'',
        img: wangzhe,
        imgPersonal:wangzheP,
        imgPink:wangzhePink
    },
    {
        id: 11,
        name: '耿廉贺',
        position:'执业律师',
        phone: '17640158979',
        language:'中文',
        code: '12101 202310696701',
        year:'3',
        educationalBackground:'',
        careerField:'民商事诉讼 / 非诉业务',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'为对银行委托的诉讼外委、逾期贷款、信用卡清收外委等业务有丰富经验，专注于金融不良资产处置、民商事诉讼及执行、合同纠纷解决，企业法律顾问等领域，承办了多起的民事一审诉讼、执行案件。同时，处理各类非诉项目，其中为委托人对不良债权资产包进行维护、清收工作，对处理该领域有一定的经验及成绩，形成了整套解决案件的方案。',
        socialAppointment:'',
        honors:'',
        img: defaultIcon,
        imgPersonal:defaultIconP,
        imgPink:defaultIconPink
    },
    {
        id: 12,
        name: '李阁',
        position:'执业律师',
        phone: '13998280150',
        language:'中文',
        code: '12101 202411831760',
        year:'2',
        educationalBackground:'',
        careerField:'婚姻家事 / 房屋交易',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'掌握专业的法律知识，拥有较为丰富的司法实践经验。擅长合同纠纷、婚姻继承纠纷、债权债务纠纷等问题的解决。从事法律职业以来参与处理过多起房屋买卖、居间合同、销售代理合同纠纷等案件，拥有较为丰富的法律实务经验。其热爱并尊重自己的工作并一直坚信唯有热爱能够抵御岁月漫长',
        socialAppointment:'',
        honors:'',
        img: lige,
        imgPersonal:ligeP,
        imgPink:ligePink
    },
    {
        id: 13,
        name: '毕莹',
        position:'执业律师',
        phone: '17640000500',
        language:'中文',
        code: '12101 202511941036',
        year:'1',
        educationalBackground:'',
        careerField:'民商事 / 刑事',
        professionalQualification:'中华人民共和国执业律师',
        personalProfile:'参与了多起民商事、刑事法律事务的处理及起草法律文件等工作，通过实践，加深了对法律实务的理解，提高了法律分析和解决问题的能力。本人性格稳重，责任心强，擅长与人沟通协调，具备团队合作精神和良好的职业素养',
        socialAppointment:'',
        honors:'',
        img: biying,
        imgPersonal:biyingP,
        imgPink:biyingPink
    },
    {
        id: 14,
        name: '韩越',
        position:'实习律师',
        phone: '15524235428',
        language:'中文',
        code: '',
        year:'',
        educationalBackground:'',
        careerField:'',
        professionalQualification:'',
        personalProfile:'一直从事法律相关工作，协调律所与法院之间的相关工作，对法律事务充满热情，也具备高强度的律师团队合作精神。本人性格开朗随和，擅于沟通，责任心强，踏实肯学，立志成为一名优秀的律师，为当事人解决问题和维护正义',
        socialAppointment:'',
        honors:'',
        img: hanyue,
        imgPersonal:hanyueP,
        imgPink:hanyuePink
    },

]

export default dataList
